import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { EditFacModalService } from '../../service/edit-fac-modal.service';
import { AutocompleteTransferModel } from './../../../../../core/models/edit-fac-modal.model';

@Component({
  selector: 'app-transfer-popup',
  templateUrl: './transfer-popup.component.html',
  styleUrls: ['./transfer-popup.component.scss']
})

export class TransferPopupComponent implements OnInit {

  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() transferEvent: EventEmitter<any> = new EventEmitter<any>();

  public autocomp = false;
  public autocompIdx = -1;
  public autoSearchResults: AutocompleteTransferModel[] = [];

  public searchForm: FormGroup;
  public transferForm: FormGroup;

  constructor(private formBuilder: FormBuilder,
              private service: EditFacModalService) { }

  ngOnInit(): void {
    this.formsInit();
  }

  formsInit(): void {
    this.transferForm = this.formBuilder.group({
      id: ['', [Validators.required]],
      name: ['', [Validators.required]],
      nickname: [''],
      profile_image_url: [''],
    });
    this.searchForm = this.formBuilder.group({
      search: ['']
    });
  }

  searchInput(event: string | number): void {
    const searchTxt = String(event).trim();
    if (searchTxt.length > 2) {
      this.autoSearchResults = [];
      this.service.autoCompleteTransfer(searchTxt).subscribe(response => {
        this.autoSearchResults = response;
        if (this.autoSearchResults.length > 3) {
          this.autoSearchResults = this.autoSearchResults.slice(0, 3);
        }
        this.autocomp = true;
      });
    } else {
      this.autocomp = false;
      this.autocompIdx = -1;
    }
  }

  pointerSelection(idx: number): void {
    this.autocompIdx = idx;
  }

  downList(event): void {
    if ((event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 27)) {
      switch (event.keyCode) {
        case 40:
          if (this.autocompIdx < this.autoSearchResults.length - 1) {
            this.autocompIdx += 1;
          }
          break;
        case 38:
          if (this.autocompIdx > 0) {
            this.autocompIdx -= 1;
          }
          break;
        case 27:
          this.autocomp = false;
          this.autocompIdx = -1;
          return;
      }
      this.updateTransferMember();
    }
  }

  patchInputValue(): void {
    this.autocomp = false;
    this.updateTransferMember();
    this.searchForm.get('search')
      .setValue(`${this.autoSearchResults[this.autocompIdx].user.nickname} - ${this.autoSearchResults[this.autocompIdx].user.name}`);
    this.autocompIdx = -1;
  }

  updateTransferMember(): void {
    this.transferForm.setValue(this.autoSearchResults[this.autocompIdx].user);
  }

  transferFac(): void {
    this.transferEvent.emit(this.transferForm.getRawValue());
    this.formsInit();
    this.closeModal.emit(true);
  }
}
